module.exports = __webpack_public_path__ + "static/comingsoondiscmain-300ad173f7d07e68414836a128a6faff.jpeg";